import {
  Component,
  ViewContainerRef,
  OnInit,
  ElementRef,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../accountant.service";
import {
  UntypedFormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { DashboardService } from "../../../dashboard.service";
import { HotToastService } from "@ngneat/hot-toast";
import * as _ from "underscore";
import { NgFor, NgIf, NgClass } from "@angular/common";
import { ActiveClientsOnlyPipe } from "../../common/active-clients-only.pipe";
declare var jQuery: any;

/* This is a component which we pass in modal*/
@Component({
  selector: "accountants-assignments-modal",
  templateUrl: "./accountants-assignments-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgFor, NgIf, NgClass, ActiveClientsOnlyPipe],
})
export class AccountantsAssignmentsModalComponent implements OnInit, OnChanges {
  clients: any;
  accountants: any;
  accountant: any = { user: { full_name: "" } };

  current_clients: any = [];

  page = 1;

  isLoading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private formBuilder: UntypedFormBuilder,
    private toastr: HotToastService,
    private _elRef: ElementRef,
    private dashboardService: DashboardService,
    private cdr: ChangeDetectorRef,
    vcr: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.loadMore();

    jQuery(function () {
      jQuery(".modal-body").scroll(function () {
        var scrollPositionV = jQuery(".modal-body").scrollTop();
        var scrollPositionH = jQuery(".modal-body").scrollLeft();
        if (scrollPositionV > 20) {
          jQuery("thead.fixed").css({
            opacity: "1",
            top: scrollPositionV,
          });
        } else {
          jQuery("thead.fixed").css({
            opacity: "0",
            top: "0",
          });
        }
        if (scrollPositionH > 15) {
          jQuery(".thead-left")
            .css({
              opacity: "1",
              left: scrollPositionH - 15,
            })
            .addClass("border-right-fixed");
        } else {
          jQuery(".thead-left")
            .css({
              opacity: "0",
              left: "11px",
            })
            .removeClass("border-right-fixed");
        }
        jQuery("thead.fixed tr").css(
          "width",
          jQuery("thead.default tr").outerWidth(),
        );
        jQuery("thead.fixed").css(
          "width",
          jQuery("thead.default").outerWidth(),
        );
        jQuery("thead.default th").each(function (index) {
          const elWidth = jQuery(this).outerWidth();
          jQuery("thead.fixed th:eq(" + index + ")").attr("width", elWidth);
        });
      });
    }); // jQuery Init
  }

  public ngOnChanges(changes: SimpleChanges) {
    console.log("manage accountant assignment changes >>>", changes);
    this.clients = changes.clients;
    this.accountants = changes.accountants;
    this.accountant = changes.accountant;

    this.accountants = this.accountants.slice();
    this.clients = this.clients.slice();

    for (let x = 0; x < this.accountants.length; x++) {
      if (this.accountants[x].id === this.accountant.id) {
        this.accountants.splice(x, 1);
        break;
      }
    }

    this.accountants.unshift(this.accountant);
    this.cdr.detectChanges();
  }

  toggleClient(client, accountant): any {
    let has_accountant =
      client.accountants.filter((a) => {
        return a.id === accountant.id;
      }).length > 0;

    if (has_accountant) {
      client.accountants = client.accountants.filter((a) => {
        return a.id != accountant.id;
      });
    } else {
      client.accountants.push(accountant);
    }

    this.cdr.detectChanges();
    return;
  }

  // this function search for all clients of an accountant
  findClients(accountant): any {
    let _c = [];
    this.clients.forEach((c) => {
      if (
        c.accountants.filter((a) => {
          return a.user.id == accountant.user.id;
        }).length > 0
      ) {
        _c.push(c.id);
      }
    });

    return _c;
  }

  saveAssignments(): any {
    this.dashboardService.show_loading.next(true);
    let clients = this.findClients(this.accountant);

    let loadedClients = this.clients.map((c) => {
      return c.id;
    });

    this.accountantService
      .save_accountant_assignments(this.accountant.id, clients, loadedClients)
      .then(
        (res: any) => {
          const response = res;

          this.toastr.success("Assignment set successfully!");
          this.dashboardService.show_loading.next(false);
          this.bsModalRef.hide();
        },
        (err) => {
          this.toastr.error(
            "Error saving assignments. Please try again or contact support.",
          );
          this.dashboardService.show_loading.next(false);
          this.bsModalRef.hide();
        },
      );
  }

  findAccountants(accountants, id) {
    return (
      accountants.filter((a) => {
        return a.user.id == id;
      }).length > 0
    );
  }

  loadMore() {
    this.isLoading = true;
    this.accountantService.get_clients_paginated(this.page).then((res: any) => {
      this.clients = this.clients.concat(res);
      this.isLoading = false;
      this.cdr.detectChanges();
    });

    this.page++;
    this.cdr.detectChanges();
  }
}
